export const BOOK_TABLE_HEADER = [
  "Обложка",
  "Название",
  "Автор",
  "Класс",
  "Год",
];
